import { render, staticRenderFns } from "./SingleIndex.vue?vue&type=template&id=147ad092&scoped=true"
import script from "./SingleIndex.vue?vue&type=script&lang=js"
export * from "./SingleIndex.vue?vue&type=script&lang=js"
import style0 from "./SingleIndex.vue?vue&type=style&index=0&id=147ad092&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147ad092",
  null
  
)

export default component.exports